import React, { useEffect, useRef, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import label from "../services/Translation/lang";

const TOAST_AUTO_CLOSE = 10 * 1000;
const TOAST_GRACE_PERIOD = 2000;

const getInactivityLimit = () => {
  const minutes = Number(sessionStorage.getItem("fastBallsSessionPopup"));
  return !isNaN(minutes) && minutes > 0 ? minutes * 60 * 1000 : 0;
};


const InactivityToast = () => {
  const [inactivityLimit, setInactivityLimit] = useState(getInactivityLimit());

  const [toastVisible, setToastVisible] = useState(false);
  const toastVisibleRef = useRef(false);
  const inactivityTimeoutRef = useRef(null);
  const graceTimeoutRef = useRef(null);
  const ignoreActivityRef = useRef(false);

  const showInactivityToast = () => {
    if (!toastVisibleRef.current) {
      toast.info(label.t("inactivity_text"), {
        toastId: "inactivity-toast",
        autoClose: TOAST_AUTO_CLOSE,
        onClose: () => {
          setToastVisible(false);
          toastVisibleRef.current = false;
        },
      });
      setToastVisible(true);
      toastVisibleRef.current = true;

      ignoreActivityRef.current = true;
      graceTimeoutRef.current = setTimeout(() => {
        ignoreActivityRef.current = false;
      }, TOAST_GRACE_PERIOD);
    }
  };

  const resetInactivityTimer = () => {
    if (ignoreActivityRef.current || inactivityLimit === 0) return;

    if (toastVisibleRef.current) {
      toast.dismiss("inactivity-toast");
      setToastVisible(false);
      toastVisibleRef.current = false;
    }

    clearTimeout(inactivityTimeoutRef.current);
    inactivityTimeoutRef.current = setTimeout(showInactivityToast, inactivityLimit);
  };

  useEffect(() => {
    setInactivityLimit(getInactivityLimit()); // in case value changes in sessionStorage
    const events = ["mousemove", "mousedown", "keydown", "touchstart", "scroll"];

    events.forEach((event) => window.addEventListener(event, resetInactivityTimer));
    if (inactivityLimit > 0) {
      inactivityTimeoutRef.current = setTimeout(showInactivityToast, inactivityLimit);
    }

    return () => {
      events.forEach((event) => window.removeEventListener(event, resetInactivityTimer));
      clearTimeout(inactivityTimeoutRef.current);
      clearTimeout(graceTimeoutRef.current);
    };
  }, [inactivityLimit]); // rerun if limit changes

  return <ToastContainer />;
};

export default InactivityToast;
